import React from 'react';
import { ProspectInformation } from '../../../interfaces/ProspectInformation';

export interface ProspectContextProps {
  prospectInfo: ProspectInformation;
  saveProspectInfo(values: ProspectInformation): void;
}

const ProspectContext = React.createContext<ProspectContextProps>(null);

/**
 * @deprecated ProspectContext has been deprecated. Please use UserAccountContext instead.
 */
export default ProspectContext;
